export const WEBsellentAccordion = () => {
    const faqSection = document.querySelectorAll('.faq-section');

    if (faqSection.length > 0) {
        faqSection.forEach(section => {
            const accordionItems = section.querySelectorAll('.faq-section__items');

            accordionItems.forEach(item => {
                const content = item.querySelector('.faq-section__collapse');
                const button = item.querySelector('.faq-section__header button');
                const iconOpen = item.querySelector('.faq-section__header .faq-section__icon-open');
                const iconClose = item.querySelector('.faq-section__header .faq-section__icon-close');

                button.addEventListener('click', () => {
                    item.classList.toggle('opened');
                    if (button.getAttribute('aria-expanded') === "false") {
                        content.style.maxHeight = content.scrollHeight + 150 + "px";
                        content.style.opacity = 1;
                        button.setAttribute('aria-expanded', 'true');
                        iconOpen.classList.add('hidden');
                        iconClose.classList.remove('hidden');
                    } else {
                        content.style.maxHeight = 0;
                        content.style.opacity = 0;
                        button.setAttribute('aria-expanded', 'false');
                        iconOpen.classList.remove('hidden');
                        iconClose.classList.add('hidden');
                    }

                });

            });

        });
    }

}